import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface NotificationsContextProps {
  // Contatore che cambia ogni volta che va richiesto un aggiornamento delle notifiche
  refreshToken: number;
  // Da chiamare dopo azioni rilevanti (prenotazione, modifica, cancellazione lezione)
  refreshNotifications: () => void;
}

const NotificationsContext = createContext<NotificationsContextProps | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [refreshToken, setRefreshToken] = useState(0);

  const refreshNotifications = useCallback(() => {
    setRefreshToken((token) => token + 1);
  }, []);

  return (
    <NotificationsContext.Provider value={{ refreshToken, refreshNotifications }}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationsProvider');
  }
  return context;
};
